module.exports = __webpack_public_path__ + "img/9.8b0d6dd1.png";